import { Navigation } from "@layouts/NavigationV2"
import Hero from './Hero';
import Cards from './Cards';
import Faq from './FAQ';
import FeedbackBanner from './FeedbackBanner';

import React from 'react';

const ScientificCollaborationProgram = () => (
    <>
            <Navigation
                staticTheme="light"
                actionTheme="light"
                background="neutral-100"
            />
        <Hero />
        <Cards />
        <Faq />
        <FeedbackBanner />
    </>
);

export default ScientificCollaborationProgram;
